import React from 'react';
import AddVideoPackageComponent from '../../../Components/VideoPackage/AddVideoPackage';

export default function AddVideoPackage() {
    return (
        <div className='page-body'>
            <AddVideoPackageComponent />
        </div>
    );
}